<div id="sidebar" class="position-relative" [ngClass]="{'collapsed': isCollapsed}">
  <a class="sidebar-header text-center w-100 d-inline-block" style="width:14rem" *ngIf="!isCollapsed">
    <mat-icon class="mat-icon" svgIcon="epin_blue_logo" style="color: var(--mainColor) !important;
    width: 12rem;
    height: 44px;">
    </mat-icon>
  </a>
  <a class="sidebar-header text-center w-100 d-inline-block" style="width:1rem" *ngIf="isCollapsed">
    <mat-icon svgIcon="epin_blue_fav" style="color: var(--mainColor) !important;
           width: 4rem;
    position: absolute;
    height: 44px;
    margin-left: -30px;
    margin-top: -18px;"></mat-icon>
  </a>
  <button class="collapse-btn" id="toggleSidebar" (click)="isCollapsed = !isCollapsed">☰</button>
  <nav class="nav flex-column mt-2 align-items-center w-100">
    <a class="nav-link" [ngClass]="{'active':currentUrl.includes('home/dashboard')}" href="/home/dashboard"
      data-outline="/assets/icons/home.svg" data-filled="/assets/icons/homeB.svg">
      <img src="/assets/icons/homeB.svg" alt="Home"> <span>Home</span>
    </a>
    <a class="nav-link" *ngIf="cardAllowed == 'Yes'" [ngClass]="{'active':currentUrl.includes('home/cards')}" href="/home/cards"
      data-outline="/assets/icons/cards.svg" data-filled="/assets/icons/cardsB.svg">
      <img src="/assets/icons/cardsB.svg" alt="Cards"> <span>Cards</span>
    </a>
    <a class="nav-link" [ngClass]="{'active':currentUrl.includes('home/transactions')}" href="/home/transactions"
      data-outline="/assets/icons/transactions.svg" data-filled="/assets/icons/transactionsB.svg">
      <img src="/assets/icons/transactionsB.svg" alt="Transactions"> <span>Transactions</span>
    </a>
     <a class="nav-link" [ngClass]="{'active':currentUrl.includes('payment')}" href="/home/payments" data-outline="/assets/icons/payment.svg" data-filled="/assets/icons/paymentB.svg">
          <img src="/assets/icons/paymentB.svg" alt="Payment"> <span>Payment</span>
        </a>
    <a class="nav-link" [ngClass]="{'active':currentUrl.includes('recipient')}" href="/home/recipients"
      data-outline="/assets/icons/users.svg" data-filled="/assets/icons/usersB.svg">
      <img src="/assets/icons/usersB.svg" alt="Recipients"> <span>Recipients</span>
    </a>

    <!-- <a class="nav-link" [ngClass]="{'active':currentUrl.includes('home/crypto')}" href="/home/crypto" data-outline="/assets/icons/currency.svg" data-filled="/assets/icons/currencyB.svg">
          <img src="/assets/icons/currencyB.svg" alt="Crypto"> <span>Crypto</span>
        </a> -->
    <!-- <a class="nav-link" [ngClass]="{'active':currentUrl.includes('home/split')}" href="/home/split" data-outline="/assets/icons/Road_Sign_Split_24.svg"
          data-filled="/assets/icons/Road_Sign_SplitB.svg">
          <img src="/assets/icons/Road_Sign_SplitB.svg" alt="Split"> <span>Split</span>
        </a>
        <a class="nav-link" [ngClass]="{'active':currentUrl.includes('home/recipients')}" href="/home/recipients" data-outline="/assets/icons/users.svg" data-filled="/assets/icons/usersB.svg">
          <img src="/assets/icons/usersB.svg" alt="Recipients"> <span>Recipients</span>
        </a> -->
  </nav>
</div>
